module.exports = __webpack_public_path__ + "img/SkeletonIcon.00795ed0.svg";